import { useEffect } from "react";

export function useDebouncedEffect(fn, deps, delay) {
  useEffect(() => {
    const tout = window.setTimeout(fn, delay);
    return () => window.clearTimeout(tout);
  }, [...deps]);
}
